import cliffCabinImgOne from "../../../img/portfolio/cliff-cabin/cliff-cabin-optimized.jpg";
import cliffCabinImgTwo from "../../../img/portfolio/cliff-cabin/cliff-cabin-2-optimized.jpg";
import cliffCabinImgThree from "../../../img/portfolio/cliff-cabin/cliff-cabin-3-optimized.jpg";
import cliffCabinImgFour from "../../../img/portfolio/cliff-cabin/cliff-cabin-4-optimized.jpg";
import cliffCabinImgFive from "../../../img/portfolio/cliff-cabin/cliff-cabin-5-optimized.jpg";
import cliffCabinImgSix from "../../../img/portfolio/cliff-cabin/cliff-cabin-6-optimized.jpg";
import cliffCabinImgSeven from "../../../img/portfolio/cliff-cabin/cliff-cabin-7-optimized.jpg";
import cliffCabinImgEight from "../../../img/portfolio/cliff-cabin/cliff-cabin-8-optimized.jpg";
import cliffCabinImgNine from "../../../img/portfolio/cliff-cabin/cliff-cabin-9-optimized.jpg";
import cliffCabinImgTen from "../../../img/portfolio/cliff-cabin/cliff-cabin-10-optimized.jpg";
import cliffCabinImgEleven from "../../../img/portfolio/cliff-cabin/cliff-cabin-11-optimalized.jpg";
import cliffCabinImgTwelve from "../../../img/portfolio/cliff-cabin/cliff-cabin-12-optimalized.jpg";

const cliffCabinImagesArray = [
  cliffCabinImgOne,
  cliffCabinImgTwo,
  cliffCabinImgThree,
  cliffCabinImgFour,
  cliffCabinImgFive,
  cliffCabinImgSix,
  cliffCabinImgSeven,
  cliffCabinImgEight,
  cliffCabinImgNine,
  cliffCabinImgTen,
  cliffCabinImgEleven,
  cliffCabinImgTwelve 
]
export default cliffCabinImagesArray;